import React from 'react';
import cx from 'classnames';

import { SiteConfigManager } from '@atlas/core';
import { Label } from '@atlas/ui';

const SearchError = () => {
  const view = SiteConfigManager.getConfig('config.config.sportsbook.mobileGridViewType');

  const className = cx('search-error-message', {
    simplified: view === 'simplified',
  });

  return <Label className={className} message={'sportsbook_search_error'} />;
};

export default SearchError;
